<script setup lang="ts">
// User Agreement, as the app shows it (components/LegalPage.vue).
</script>

<template>
  <LegalPage doc="agreement" />
</template>
